// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarHireOptionsHeader-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarHireOptionsHeader.mobile.scss
 ** module id = 899
 ** module chunks = 1
 **/